import React from 'react';

const JavaScript = () => {
  return (
    <div className="content-page">
      <h1>JavaScript Tutorial</h1>
      
      <div className="tutorial-section">
        <h2>What is JavaScript?</h2>
        <p>JavaScript is a programming language that adds interactivity to your website. This happens in games, in the behavior of responses when buttons are pressed or with data entry on forms; with dynamic styling; with animation, etc.</p>
      </div>

      <div className="example">
        <h3>Example</h3>
        <div className="code-container">
          <pre>{`// Change the text of an HTML element
document.getElementById("demo").innerHTML = "Hello JavaScript";

// Change the style of an HTML element
document.getElementById("demo").style.fontSize = "25px";

// Hide an HTML element
document.getElementById("demo").style.display = "none";

// Show a hidden HTML element
document.getElementById("demo").style.display = "block";`}</pre>
          <button className="try-it-btn">Try it Yourself »</button>
        </div>
      </div>

      <div className="tutorial-navigation">
        <button className="btn-prev">❮ Previous</button>
        <button className="btn-next">Next ❯</button>
      </div>
    </div>
  );
};

export default JavaScript;
